import { Drawer } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { BookingsSection } from '../../elements/BookingsSection/BookingsSection'
import { DetailsSection } from '../../elements/DetailsSection'
import { HeroSection } from '../../elements/HeroSection'
import { Separator } from '../../elements/Separator'

export const ConversionBalanceView = () => {
  const { t } = useTranslation()
  const { transactionNo, transaction } = useTransactionDrawerContext()
  const { organization } = useUserOrganization()

  const { createdTime, entryDate } = transaction || {}

  return (
    <>
      <Drawer.Header closable title={t('ledger.drawer_title', { number: transactionNo })} />
      <Drawer.Body withPadding={false} gap="0">
        <HeroSection amount={null} entryDate={entryDate} />
        <Separator />
        <BookingsSection originatorCurrency={organization?.baseCurrencyId} withTotal={false} />
        <Separator />
        <DetailsSection createdTime={createdTime} />
        <Separator />
      </Drawer.Body>
    </>
  )
}
